import { FC } from 'react';

import { CountChips } from '../../../../../components/CountChip';

import {
    InventorySourceTypeGroup as DspInventorySourceTypeGroup,
    InventorySource as DspInventorySource,
} from '../../../../../types/Inventory';
import DspInventorySourceUtils from '../../../../../utils/DspInventorySourceUtils';

interface CampaignAdGroupInventoryChipsProps {
    items: DspInventorySource[];
}

const CampaignAdGroupInventoryChips: FC<CampaignAdGroupInventoryChipsProps> = ({ items }) => {
    const groups: DspInventorySourceTypeGroup[] = DspInventorySourceUtils.toDspInventorySourceTypeGroups(items);

    return (
        <CountChips
            items={groups.map((group: DspInventorySourceTypeGroup) => {
                return {
                    label: group.inventorySourceType,
                    count: group.inventorySources.length,
                };
            })}
        />
    );
};

export default CampaignAdGroupInventoryChips;
